import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { RiAlertLine, RiEditBoxLine } from 'react-icons/ri';
import { BsArrowReturnRight, BsCheckCircle, BsUpload } from 'react-icons/bs';
import { BadgeActive, Text } from 'v3/components';
import { QuestionOptionItemComponent } from '../components/QuestionOptionItem';
import { cooperplaceApi } from 'services/api';
import {
  QuestionDetailContainer,
  QuestionsSectionContainer,
} from '../shared/styles';

import theme from 'v3/theme'
import { FaQuestionCircle } from 'react-icons/fa'
import Tooltip from 'v3/components/Tooltip'
import * as Styled from 'v3/components/Select/styles'  
import { QuestionItem } from '../components/RegisterComponents/QuestionItem';

export function GeneralInfo({ checklist }) {

  const {
    defaultCostCenter,
    costCenters = [],      
    serviceLevels = [],    
  } = checklist.data || {}

  const levelNameMap = {
    'Próprios': 'Frota',
    'Agregado – Ouro': 'Agregado – Ouro',
    'Agregado – Bronze': 'Agregado – Bronze',
    'Terceiro': 'Terceiro',
  };

  const isSingle = checklist?.data?.checklistType?.slug === 'SeparateChecklist';
  const checklistTypeSlug = String(
    checklist?.data?.checklistType?.slug || ''
  ).toLowerCase();
  const checklistTypeName = String(
    checklist?.data?.checklistType?.name || checklist?.data?.checklistType?.label || ''
  )
    .trim()
    .toLowerCase();
  const isTraining =
    checklistTypeSlug === 'training' || checklistTypeName === 'treinamento';
  const courseWorkload =
    checklist?.data?.courseWorkload || checklist?.data?.course_workload;
  const levelsToShow = isSingle
  ? [
      {
        name: 'Avulso',
        checklistDays: checklist?.data?.singleDays ?? 0,
        travelQuantity: checklist?.data?.singleLinkResponses ?? 0,
        orAnd: true, 
        unit: 'respostas',
      },
    ].filter(l => (l.checklistDays > 0 || l.travelQuantity > 0))
  : (checklist?.data?.serviceLevels || []).filter(
      l => l.checklistDays > 0 || l.travelQuantity > 0
    );

  if (isTraining) {
    return (
      <Row>
        <Col xs={12} className="mb-4">
          <Text weight={500} color="dark" type="header">
            Dados gerais
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Título:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.name}
          </Text>
        </Col>
        <Col md={8} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Descrição do checklist:
          </Text>
          <Text weight={400} color="dark" type="body" as="p" style={{ 'word-wrap': 'break-word'}}>
            {checklist?.data?.description}
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Tipo de checklist:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.checklistType?.name}
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Duração do treinamento:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {courseWorkload || 'Não informado'}
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Ativo:
          </Text>
          <span className="d-block">
            <BadgeActive
              pill
              light
              type={checklist?.data?.active ? 'success' : 'error'}
            >
              <Text type="label" weight={500}>
                {checklist?.data?.active ? 'Ativo' : 'Inativo'}
              </Text>
            </BadgeActive>
          </span>
        </Col>
        <Col xs={12}>
          <div
            style={{
              borderTop: '1px solid #dee2e6',
              margin: '1rem 0',
            }}
          />
        </Col>
      </Row>
    );
  }

  if (isSingle) {
    return (
      <Row>
        <Col xs={12} className="mb-4">
          <Text weight={500} color="dark" type="header">
            Dados gerais
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Ativo:
          </Text>
          <span className="d-block">
            <BadgeActive
              pill
              light
              type={checklist?.data?.active ? 'success' : 'error'}
            >
              <Text type="label" weight={500}>
                {checklist?.data?.active ? 'Ativo' : 'Inativo'}
              </Text>
            </BadgeActive>
          </span>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Habilitado para APP Checklist:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.appVisible ? 'Sim' : 'Não'}
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Título:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.name}
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Tipo de checklist:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.checklistType?.name}
          </Text>
        </Col>
        <Col md={8} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Descrição do checklist:
          </Text>
          <Text weight={400} color="dark" type="body" as="p" style={{ 'word-wrap': 'break-word'}}>
            {checklist?.data?.description}
          </Text>
        </Col>
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Grupos do checklist:
          </Text>
          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.groups?.length > 0
              ? checklist.data.groups.map(g => g.name).join(', ')
              : 'Não informado'}
          </Text>
        </Col>
        <Col xs={12}>
          <Text weight={500} color="dark" type="regular">
            Validade do CheckList:
          </Text>

          {levelsToShow.length > 0 ? (
            levelsToShow.map(level => {
              const validityParts = [];

              if (level.checklistDays > 0) validityParts.push(`por ${level.checklistDays} dias`);

              if (level.travelQuantity > 0) {
                const unit = 'respostas';
                validityParts.push(`até ${level.travelQuantity} ${unit}`);
              }

              const validityLabel =
                validityParts.length > 0 ? `Válido ${validityParts.join(' e ')}` : 'Não informado';

              let expiresLabel = '';
              if (level.checklistDays > 0 && level.travelQuantity > 0) {
                expiresLabel = 'Expira apenas se atingir dias OU respostas';
              } else if (level.checklistDays > 0) {
                expiresLabel = 'Expira apenas se atingir dias';
              } else if (level.travelQuantity > 0) {
                expiresLabel = 'Expira apenas se atingir respostas';
              }

              return (
                <div key={level.name} style={{ marginBottom: 8 }}>
                  <Text
                    weight={400}
                    color="dark"
                    type="body"
                    as="p"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <strong>Checklist avulso:</strong>
                    &nbsp;{validityLabel}

                    {expiresLabel && (
                      <Tooltip
                        placement="top"
                        content={<Styled.ToolTipLabel type="label" color="white">{expiresLabel}</Styled.ToolTipLabel>}
                      >
                        <FaQuestionCircle style={{ marginLeft: 4, color: theme.colors.light_blue, cursor: 'pointer' }} />
                      </Tooltip>
                    )}
                  </Text>
                </div>
              );
            })
          ) : (
            <Text weight={400} color="dark" type="body" as="p">
              Não informado
            </Text>
          )}
        </Col>
        <Col xs={12}>
          <div
            style={{
              borderTop: '1px solid #dee2e6',
              margin: '1rem 0',
            }}
          />
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col xs={12} className="mb-4">
        <Text weight={500} color="dark" type="header">
          Dados gerais
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Título:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.name}
        </Text>
      </Col>
      <Col md={8} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Descrição do checklist:
        </Text>
        <Text weight={400} color="dark" type="body" as="p" style={{ 'word-wrap': 'break-word' }}>
          {checklist?.data?.description}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Tipo de checklist:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.checklistType?.name}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Checklist Obrigatório:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.required ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Motorista responde pelo APP:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.availableForDriver ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Apresentado no painel logístico:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.availableLogisticPanel ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Requer assinatura motorista:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.requiredDriverSign ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Requer assinatura inspetor:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.requiredInspectSign ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Checklist padrão filial:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.default ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Status do checklist:
        </Text>
        <span className="d-block">
          <BadgeActive pill light type={checklist?.data?.active ? 'success' : 'error'}>
            <Text type="label" weight={500}>
              {checklist?.data?.active ? 'Ativo' : 'Inativo'}
            </Text>
          </BadgeActive>
        </span>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Possui CNPJ(s) vinculado(s)?
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.clients?.length > 0 ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Possui negociação vinculada?
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.negotiation ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Possui veículo(s) vinculado(s)?
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.vehicleType?.length > 0 ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Possui carroceria(s) vinculada(s)?
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.vehicleType?.length > 0 ? 'Sim' : 'Não'}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Checklist padrão Centro de Custo:
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {defaultCostCenter ? 'Sim' : 'Não'}
        </Text>
      </Col>

      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Possui centro(s) de Custo vinculado(s)?
        </Text>
        <Text weight={400} color="dark" type="body" as="p">
          {costCenters.length > 0
            ? costCenters.map(cc => cc.name).join(', ')
            : 'Não possui'}
        </Text>
      </Col>

      {checklist?.data?.checklistType?.slug === 'SeparateChecklist' && (
        <Col md={4} xs={12}>
          <Text weight={500} color="dark" type="regular">
            Grupos do checklist:
          </Text>

          <Text weight={400} color="dark" type="body" as="p">
            {checklist?.data?.groups?.length > 0
              ? checklist.data.groups.map(g => g.name).join(', ')
              : 'Não informado'}
          </Text>
        </Col>
      )}
            
      <Col xs={12}>
        <Text weight={500} color="dark" type="regular">
          Validade do CheckList:
        </Text>

        {levelsToShow.length > 0 ? (
          levelsToShow.map(level => {
            const validityParts = [];

            if (level.checklistDays > 0) validityParts.push(`por ${level.checklistDays} dias`);

            if (level.travelQuantity > 0) {
              const unit = isSingle ? 'respostas' : 'viagens';
              validityParts.push(`até ${level.travelQuantity} ${unit}`);
            }

            const validityLabel =
              validityParts.length > 0 ? `Válido ${validityParts.join(' e ')}` : 'Não informado';

            let expiresLabel = '';
            if (level.checklistDays > 0 && level.travelQuantity > 0) {
              const conj = level.orAnd ? 'OU' : 'E';
              const unit = isSingle ? 'respostas' : 'viagens';
              expiresLabel = `Expira apenas se atingir dias ${conj} ${unit}`;
            } else if (level.checklistDays > 0) {
              expiresLabel = 'Expira apenas se atingir dias';
            } else if (level.travelQuantity > 0) {
              expiresLabel = isSingle
                ? 'Expira apenas se atingir respostas'
                : 'Expira apenas se atingir viagens';
            }

            return (
              <div key={level.name} style={{ marginBottom: 8 }}>
                <Text
                  weight={400}
                  color="dark"
                  type="body"
                  as="p"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <strong>{isSingle ? 'Checklist avulso' : (levelNameMap[level.name] || level.name)}:</strong>
                  &nbsp;{validityLabel}

                  {expiresLabel && (
                    <Tooltip
                      placement="top"
                      content={<Styled.ToolTipLabel type="label" color="white">{expiresLabel}</Styled.ToolTipLabel>}
                    >
                      <FaQuestionCircle style={{ marginLeft: 4, color: theme.colors.light_blue, cursor: 'pointer' }} />
                    </Tooltip>
                  )}
                </Text>
              </div>
            );
          })
        ) : (
          <Text weight={400} color="dark" type="body" as="p">
            Não informado
          </Text>
        )}
      </Col>

       <Col xs={12}>
        <div
          style={{
            borderTop: '1px solid #dee2e6',
            margin: '1rem 0',
          }}
        />
      </Col>
    </Row>
  );
}
export function ClientInfo({ checklist }) {
  return (
    <Row>
      <Col xs={12}>
        <Text weight={500} color="dark" type="header">
          Cliente(s)
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={400} color="dark" type="body" as="p">
          {`${checklist?.data?.clients[0]?.socialName} - ${checklist?.data?.clients[0]?.cpfCnpj}`}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Negociação:
        </Text>

        <Text weight={400} color="dark" type="body" as="p">
          {checklist?.data?.negotiation?.name}
        </Text>
      </Col>
      <Col md={4} xs={12}>
        <Text weight={500} color="dark" type="regular">
          Status Negociação:
        </Text>
        <span className="d-block">
          <BadgeActive pill light type={checklist?.data?.negotiation?.active ? 'success' : 'error'}>
            <Text type="label" weight={500}>
              {checklist?.data?.negotiation?.active ? 'Ativa' : 'Inativa'}
            </Text>
          </BadgeActive>
        </span>
      </Col>

       <Col xs={12}>
        <div
          style={{
            borderTop: '1px solid #dee2e6',
            margin: '1rem 0',
          }}
        />
      </Col>
    </Row>
  );
}

export function ClientsInfo({ checklist }) {
  return (
    <Row>
      <Col xs={12} className="mt-2">
        <Text weight={500} color="dark" type="header">
          Clientes(s)
        </Text>
      </Col>
      {checklist?.data?.clients?.map((client) => {
        return (
          <Col md={12} xs={12} key={client?.personId}>
            <Text weight={400} color="dark" type="body" as="p" style={{ marginBottom: '0.3rem' }}>
              {`${client?.cpfCnpj} - ${client?.socialName?.toUpperCase()}`}
            </Text>
          </Col>
        );
      })}
    </Row>
  );
}

export function VehiclesInfo({ checklist }) {
  return (
    <Row>
      <Col xs={12} className="mt-2">
        <Text weight={500} color="dark" type="header">
          Tipos de Veículos
        </Text>
      </Col>
      {checklist?.data?.vehicleType?.map((vehicle) => {
        return (
          <Col md={3} xs={12}>
            <Text weight={400} color="dark" type="body" as="p" style={{ marginBottom: '0.3rem' }}>
              {vehicle?.name}
            </Text>
          </Col>
        );
      })}
    </Row>
  );
}

export function VehiclesBodyInfo({ checklist }) {
  return (
    <Row>
      <Col xs={12} className="mt-2">
        <Text weight={500} color="dark" type="header">
          Tipos de Carrocerias
        </Text>
      </Col>
      {checklist?.data?.vehicleBodyType?.map((body) => {
        return (
          <Col md={3} xs={12}>
            <Text weight={400} color="dark" type="body" as="p" style={{ marginBottom: '0.3rem' }}>
              {body?.name}
            </Text>
          </Col>
        );
      })}
    </Row>
  );
}

export function ImplementsInfo({ checklist }) {
  return (
    <Row>
      <Col xs={4} className="mt-2">
        <Text weight={500} color="dark" type="header">
          Tipos de Implementos
        </Text>
      </Col>
      {checklist?.data?.implementType?.map((body) => {
        return (
          <Col md={4} xs={12} key={body?.id}>
            <Text weight={400} color="dark" type="body" as="p" style={{ marginBottom: '0.3rem' }}>
              {body?.name}
            </Text>
          </Col>
        );
      })}
    </Row>
  );
}

export function BranchOfficesInfo({ checklist }) {
  return (
    <Row>
      <Col xs={12} className="mt-2">
        <Text weight={500} color="dark" type="header">
          Filial(s)
        </Text>
      </Col>
      {checklist?.data?.branchOffices?.map(({ name }) => (
        <Col md={3} xs={12}>
          <Text weight={400} color="dark" type="body" as="p" style={{ marginBottom: '0.3rem' }}>
            {name}
          </Text>
        </Col>
      ))}

       <Col xs={12}>
        <div
          style={{
            borderTop: '1px solid #dee2e6',
            margin: '1rem 0',
          }}
        />
      </Col>
    </Row>
  );
}

export function QuestionsSection({ checklist }) {
  const [questionsData, setQuestionsData] = useState(checklist?.data?.checklistsQuestions || []);

  useEffect(() => {
    let isMounted = true;

    const hasVideoMedia = question =>
      !!(
        question?.originalQuestion?.media?.full_path ||
        question?.originalQuestion?.media?.fullPath ||
        question?.originalQuestion?.media?.url
      );

    async function hydrateVideoQuestions() {
      const rawQuestions = checklist?.data?.checklistsQuestions || [];

      const hydrated = await Promise.all(
        rawQuestions.map(async item => {
          const question = item?.question || {};
          const typeSlug = String(question?.type?.slug || '').toLowerCase();
          const shouldHydrateQuestion =
            (!typeSlug || typeSlug === 'video_visualization') &&
            !hasVideoMedia(question);

          if (!shouldHydrateQuestion || !question?.id) {
            return item;
          }

          try {
            const { data } = await cooperplaceApi.get(`questions/${question.id}`);
            return {
              ...item,
              question: {
                ...question,
                ...data,
                media: data?.media || question?.media,
                mediaId: data?.mediaId || question?.mediaId,
                originalQuestion:
                  data?.originalQuestion || question?.originalQuestion,
              },
            };
          } catch (error) {
            return item;
          }
        })
      );

      if (isMounted) {
        setQuestionsData(hydrated);
      }
    }

    hydrateVideoQuestions();

    return () => {
      isMounted = false;
    };
  }, [checklist?.data?.checklistsQuestions]);

  return (
    <Row>
      <Col xs={12} className="my-2">
        <Text weight={500} color="dark" type="header">
          Lista de perguntas
        </Text>
      </Col>
      <Col md={12}>
        <QuestionsSectionContainer>
          {questionsData?.map(question => {
            return (
              <QuestionDetailContainer key={question?.question?.id}>
                <div className="contentContainer">
                  <QuestionItem question={question?.question} />
                  <div className="questionOptions">
                    {question?.required && (
                      <QuestionOptionItemComponent icon={RiAlertLine} content="Obrigatória" />
                    )}
                    {question?.question?.needAttachment && (
                      <QuestionOptionItemComponent icon={BsUpload} content="Necessário anexo" />
                    )}
                    {question?.question?.subQuestion && (
                      <QuestionOptionItemComponent
                        icon={BsArrowReturnRight}
                        content=" Subpergunta"
                      />
                    )}
                    {question?.question?.createOccurrence && (
                      <QuestionOptionItemComponent content="Gera ocorrência" icon={RiEditBoxLine} />
                    )}
                    {(question?.question?.hasCorrectAnswer) && (
                      <QuestionOptionItemComponent
                        content="Exige resposta correta"
                        icon={BsCheckCircle}
                      />
                    )}
                  </div>
                </div>
              </QuestionDetailContainer>
            );
          })}
        </QuestionsSectionContainer>
      </Col>
    </Row>
  );
}
